import templateUrl from './cycleCounts.view.html'

/**
 * CycleCount view route
 *
 * @namespace routes.ReportCycleCountView
 * @type {TmrRoute}
 */
export const route = {
  name: 'report.cycleCount.view',
  label: 'REPORT.CYCLECOUNT.VIEW.TITLE',
  component: 'tmrReportCycleCountView',
  paging: true,
  resolve: {
    aggregatedItems: /*@ngInject*/ (
      $transition$,
      CycleCountItem,
      TmrPaging,
      resource
    ) =>
      CycleCountItem.aggregatedItems(
        TmrPaging.resolveParams($transition$, { id: resource.id })
      ),
    aggregatedCount: /*@ngInject*/ (CycleCountItem, resource) =>
      CycleCountItem.aggregatedCount({ id: resource.id }),
  },
  accessControl: ['Resource.view', 'Resource.CycleCount.view'],
  abstract: false,
}

/**
 * Component for {@link routes.tmrReportCycleCountView CycleCount view route}
 *
 * @type {ngComponent}
 */
export const tmrReportCycleCountView = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrReportCycleCountViewController',
  bindings: {
    resource: '<',
    aggregatedItems: '<',
    aggregatedCount: '<',
    currentPage: '<',
    pageSize: '<',
  },
}

/**
 * Controller of component {@link tmrReportCycleCountView}.
 *
 * @type {ngController}
 */

export class tmrReportCycleCountViewController {
  static ngType = 'controller'
}
